import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Contact() {
  const [formData, setFormData] = useState({
    naam: '',
    email: '',
    organisatie: '',
    telefoon: '',
    bericht: '',
    privacy: false
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // In productie: verstuur naar PHP backend
    // Voor nu: simuleer succesvolle verzending
    setTimeout(() => {
      setStatus({
        type: 'success',
        message: 'Bedankt voor uw bericht! Wij nemen zo spoedig mogelijk contact met u op.'
      });
      setFormData({ naam: '', email: '', organisatie: '', telefoon: '', bericht: '', privacy: false });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <>
      {/* Page Hero */}
      <section className="bg-[#2d5e5e] pt-32 pb-16 text-center text-white">
        <div className="max-w-6xl mx-auto px-5">
          <h1 className="text-3xl font-bold mb-3">Contact</h1>
          <p className="text-lg opacity-90">Neem vrijblijvend contact met ons op</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-5">
          <div className="grid md:grid-cols-5 gap-12">
            {/* Info */}
            <div className="md:col-span-2">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Neem contact op</h2>
              <p className="text-gray-600 mb-8">
                Heeft u vragen over onze diensten of wilt u meer informatie?
                Vul het formulier in en wij nemen zo snel mogelijk contact met u op.
              </p>

              <div className="bg-gray-100 rounded-xl p-6 mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Registraties</h3>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="fas fa-building text-[#2d5e5e]"></i>
                    KvK: 88552489
                  </li>
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="fas fa-id-card text-[#2d5e5e]"></i>
                    BIG: 79913336601
                  </li>
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="fas fa-file-medical text-[#2d5e5e]"></i>
                    AGB: 03102142
                  </li>
                </ul>
              </div>

              <div className="bg-[#2d5e5e] rounded-xl p-6 text-white">
                <h3 className="text-lg font-semibold mb-3 flex items-center gap-3">
                  <i className="fas fa-file-invoice"></i>
                  Liever direct een offerte?
                </h3>
                <p className="opacity-90 mb-4 text-sm">
                  Vraag direct een offerte aan met onze ureninkoop calculator.
                </p>
                <Link to="/offerte" className="btn-accent w-full justify-center text-sm">
                  Naar offerte aanvraag <i className="fas fa-arrow-right ml-2"></i>
                </Link>
              </div>
            </div>

            {/* Form */}
            <div className="md:col-span-3">
              <div className="bg-white rounded-2xl p-10 shadow-lg border border-gray-200">
                <form onSubmit={handleSubmit}>
                  <div className="grid md:grid-cols-2 gap-5 mb-5">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Naam *</label>
                      <input
                        type="text"
                        required
                        value={formData.naam}
                        onChange={(e) => setFormData({...formData, naam: e.target.value})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#2d5e5e] focus:outline-none transition-colors"
                        placeholder="Uw naam"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">E-mailadres *</label>
                      <input
                        type="email"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#2d5e5e] focus:outline-none transition-colors"
                        placeholder="uw@email.nl"
                      />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-5 mb-5">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Organisatie</label>
                      <input
                        type="text"
                        value={formData.organisatie}
                        onChange={(e) => setFormData({...formData, organisatie: e.target.value})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#2d5e5e] focus:outline-none transition-colors"
                        placeholder="Naam organisatie"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Telefoonnummer</label>
                      <input
                        type="tel"
                        value={formData.telefoon}
                        onChange={(e) => setFormData({...formData, telefoon: e.target.value})}
                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#2d5e5e] focus:outline-none transition-colors"
                        placeholder="06-12345678"
                      />
                    </div>
                  </div>

                  <div className="mb-5">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Bericht *</label>
                    <textarea
                      required
                      rows={5}
                      value={formData.bericht}
                      onChange={(e) => setFormData({...formData, bericht: e.target.value})}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#2d5e5e] focus:outline-none transition-colors resize-y"
                      placeholder="Uw bericht..."
                    />
                  </div>

                  <div className="mb-6">
                    <label className="flex items-start gap-3 cursor-pointer text-sm text-gray-600">
                      <input
                        type="checkbox"
                        required
                        checked={formData.privacy}
                        onChange={(e) => setFormData({...formData, privacy: e.target.checked})}
                        className="mt-1 w-5 h-5 accent-[#2d5e5e]"
                      />
                      <span>
                        Ik ga akkoord met de verwerking van mijn gegevens *
                      </span>
                    </label>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full btn-primary justify-center disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? 'Verzenden...' : 'Verstuur bericht'}
                    <i className="fas fa-paper-plane ml-2"></i>
                  </button>

                  {status.message && (
                    <div className={`mt-5 p-4 rounded-lg ${
                      status.type === 'success' 
                        ? 'bg-green-50 text-green-800 border border-green-200' 
                        : 'bg-red-50 text-red-800 border border-red-200'
                    }`}>
                      {status.message}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
